export const GENERIC_UNPACKING_DESCRIPTION =
  'Break down learning competencies efficiently! Input the subject, grade level, and learning competency to unpack, and our tool will generate a comprehensive breakdown into 5 learning competencies for deeper understanding and better lesson planning.';

export const GENERIC_UNPACKING_TITLE = 'Learning Competency';

export const GENERIC_UNPACKING_DEFAULT_UNPACK_TYPE = 'Learning Competency';

export const GENERIC_UNPACKING_ITEM_CHAR_LIMIT = 1000;

export const LEARNING_COMPETENCY_TUTORIAL_DESKTOP_URL = `${process.env.NEXT_PUBLIC_GOOGLE_CDN}/images/tutorials/tutorialLearningCompetencyDesktop.webp`;
export const LEARNING_COMPETENCY_TUTORIAL_MOBILE_URL = `${process.env.NEXT_PUBLIC_GOOGLE_CDN}/images/tutorials/tutorialLearningCompetencyMobile.webp`;
